export enum AnalyticsAppStore {
  APPLE = 'APPLE_STORE',
  PLAY = 'GOOGLE_PLAY_STORE',
  HUAWEI = 'HUAWEI_STORE',
}
